// GetMetaData returns the meta data for the brand shop page.
export const BrandHubPageMetaService_GetMetaDataLazy = () =>
  import("./service.grpc").then((m) => m.BrandHubPageMetaService_GetMetaData);
BrandHubPageMetaService_GetMetaDataLazy.method =
  "aysa_api.services.brand_hub.v1.meta.BrandHubPageMetaService/GetMetaData" as const;

// GetDiscoverMetaData returns the meta data for the brand discover page.
export const BrandHubPageMetaService_GetDiscoverMetaDataLazy = () =>
  import("./service.grpc").then(
    (m) => m.BrandHubPageMetaService_GetDiscoverMetaData
  );
BrandHubPageMetaService_GetDiscoverMetaDataLazy.method =
  "aysa_api.services.brand_hub.v1.meta.BrandHubPageMetaService/GetDiscoverMetaData" as const;
